<script>
export default {
  name: "CustomListMenu",
  props: {
    items: {
      type: Array,
      required: true,
    },
    details: {
      type: Array,
      required: false,
    },
    id: {
      type: Int16Array,
      required: true,
    },
  },
  data: () => ({
    last: "",
  }),
  methods: {
    openAction(index, title) {
      const data = {
        index: index,
        title: title,
        selectedId: this.$props.id,
        details: this.$props.details,
      };
      this.$emit("actionMenu", data);
    },
    click() {
      this.$emit("selectRow", this.$props.id, this.$props.details);
    },
  },
  components: {},
};
</script>
<style>
.listHover {
  border-bottom: 1px solid var(--v-gray1-base);
}
.listHover:hover {
  background-color: var(--v-orange-base);
  transition: 0.2s all ease-in-out !important;
  color: white !important;
}
.listHover:hover > .v-list-item__icon > .v-icon {
  color: #ffffff;
}
/* .v-list-item__title,
.v-list-item__subtitle {
  white-space: nowrap !important;
} */

.v-icon {
  color: #2b2b44;
}
</style>
<template>
  <v-sheet class="transparent">
    <v-menu
      :close-on-content-click="true"
      class="menu-to-print"
      offset-y
      id="optionList"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          size="x-small"
          color="gray0"
          v-bind="attrs"
          v-on="on"
          outlined
          @click="click"
          class="pa-0"
        >
          <v-icon color="gray0">mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>

      <v-card
        dark
        elevation="0"
        rounded="0"
        class="prime d-flex align-center justify-end"
        height="35px"
      >
        <v-btn icon dark>
          <v-icon color="orange">mdi-close</v-icon>
        </v-btn>
      </v-card>

      <v-list
        class="pa-0"
        :style="{
          border: 'solid 2px var(--v-prime-base)',
        }"
      >
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click.stop="openAction(index, item.title)"
          :style="{
            width: '200px',
          }"
          class="listHover"
        >
          <v-list-item-icon class="mx-0 d-flex align-center justify-center">
            <v-icon size="large" class="px-3">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="white-space: normal !important">
              {{ $t(item.title) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-sheet>
</template>
